export default {
  initDropZones: function(vm, el){
    var $el = el;
    var dz;

    var $editor = $el.parent().parent();
    var url = Kadenze.Routes.admin_external_imports_path();
    let redirectUrl;

    if(vm.type == 'course') {
      redirectUrl = Kadenze.Routes.admin_courses_path();
    } else {
      redirectUrl = Kadenze.Routes.admin_users_path();
    }
    var $imageInput = $el.find('input[name=\'full\']');
    var $thumbInput = $el.find('input[name=\'thumb\']');

    var msgText = 'msgText';
    var subMsgText = 'subMsgText';

    var templateConfig = $el.data('dz-config');
    var message = JST['templates/dropzone-course-import'](templateConfig);

    message = Kadenze.I18n.tt(message, 'en');

    var curFileObj;
    if ($imageInput.length > 0) {
      var imgPath = ( $imageInput.val() )? $thumbInput.val() : '';
      curFileObj = {
        path: imgPath
      };
    }

    var options = {
      method: 'POST',
      dzName: 'course-import',
      previewable: true,
      dzPreview: JST['templates/dropzone-import-preview'](),
      maxFilesize: templateConfig.maxFilesize,
      acceptedFiles: templateConfig.acceptedFiles,
      autoProcessQueue: false
    };

    try { if(Dropzone.forElement('#' + $el.attr('id'))) { return; } }
    catch(err) { }

    var callbacks = {
      addedfile: function( file, xhr, formData ){
        $('.dz-img__progress_holder').hide();
      },
      sending: function( file, xhr, formData ){
        formData.append('term_id', vm.selectedTerm());
        formData.append('institution_id', vm.selectedInstitution());
        formData.append('send_institution_invite', vm.sendInstitutionInvite());
        formData.append('g-recaptcha-token', localStorage.getItem("recaptcha_token"));
        formData.append('send_course_welcome', vm.sendCourseWelcome());
        formData.append('type', vm.type);
        if(vm.ccImport)
          formData.append('common_cartridge', vm.commonCartridge());
      },
      success: function( file, response ) {
        Kadenze.UIUtil.showNotice($editor, {message: response.message, status:'success'}, 300);
        window.location.replace(redirectUrl);
      },
      error: function( file, errorMessage ) {
        vm.removeFile();
        Kadenze.UIUtil.showNotice($editor, {message:errorMessage}, 300);
      },
      complete: function( file ) {
        Kadenze.UIUtil.hideLoadingIndicator($editor);
      }
    };
    dz = new Kadenze.ImageDropZone($el, message, url, callbacks, curFileObj, options );
    localStorage.removeItem("recaptcha_token");
    return dz;
  }
};
